import React from 'react';
import '../styles/Header.css';
import { motion } from 'framer-motion';

function Header() {
  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="container">
        <div className="logo">
          <h1>Ari Lashes & Brow</h1>
          <p>El arte de realzar tu mirada</p>
        </div>
      </div>
    </motion.header>
  );
}

export default Header;